import React from "react";
import "./HowItWorks.css";

const stepData = [
  {
    id: 1,
    text: (
      <>
        Provide basic <br />
        details.
      </>
    ),
    className: "step-one",
  },
  {
    id: 2,
    text: (
      <>
        Compare and <br />
        Select Offer.
      </>
    ),
    className: "step-two",
  },
  {
    id: 3,
    text: (
      <>
        Complete <br />
        Application Form.
      </>
    ),
    className: "step-three",
  },
  {
    id: 4,
    text: "Sign Agreement and Loan amount is credited.",
    className: "step-four",
  },
];


const HowItWorks = () => {
  return (
    <div className="hiw-container-v6">
      <h2 className="hiw-heading-v6">How it Works</h2>
      <div className="hiw-content-wrapper-v6">
        <img
          src="/assets/img/How it works Green.png"
          alt="How it Works"
          className="hiw-image-v6"
        />
        <div className="hiw-text-wrapper-v6">
          {stepData.map((step) => (
            <div key={step.id} className={`hiw-step-v6 ${step.className}-v6`}>
              {step.text}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
